/* eslint-disable eqeqeq */
/* eslint-disable import/prefer-default-export */

import _ from 'lodash';

const toNumber = (x) => {
  const float = _.isString(x) ? parseFloat(x) : x;
  return _.isNaN(float) ? 0 : float;
}

export const tradeDiscountStr = (_retail, _trade, allowEmpty) => {
  const retail = toNumber(_retail);
  const trade = toNumber(_trade);
  if (retail == 0 && trade == 0) return '';
  if (trade == 0) return allowEmpty ? '' : 'Invalid trade price';
  if (trade > (retail || 0)) return 'Please check TP Price cannot greater than RP Price';
  return `${100 - Math.round(trade / retail * 100)}% OFF`;
};

export const commaSeparatedToNumbers = (str) => [
  ...new Set(_.isString(str) ? str.split(/,\s?/).reduce((acc, cur) => {
    const id = parseInt(cur, 10);
    return _.isNaN(id) ? acc : [...acc, id];
  }, []) : []),
];
